module.exports = __webpack_public_path__ + "img/diy-eye-open.c716f121.svg";